import { ActivatedRoute, ResolveFn } from '@angular/router';
import { EnvironmentInjector, inject, Injector } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { modalFn } from '@softline/ui-core';
import { handleRequestError } from '@softline/application';
import { map } from 'rxjs';
import { SelfCheckoutTerminalInitService as TerminalInitService } from '@softapps/wws/pos-core';
import {
  TERMINAL_MODAL_INIT,
  TERMINAL_MODAL_SSE_KEY,
  TerminalModalComponent,
} from '@softapps/wws/pos-core';

export const posConfigurationResolver: ResolveFn<any> = async (route) => {
  const service = inject(ApiDataAccess);
  const modal = modalFn();
  const injector = inject(Injector);
  const environmentInjector = inject(EnvironmentInjector);
  const activatedRoute = inject(ActivatedRoute);
  const terminalService = inject(TerminalInitService);

  const config = await service.get<{ terminalSseKey?: string }>({
    path: '/pointofsale-service/point-of-sale/configuration',
  });

  console.log('EXIT_ ', route.queryParams);

  console.log(route);

  // when config is explicitly set to false, then skip init/close and activate route
  console.log('Config Resolver: ', config, terminalService.state());

  if (terminalService.state() === 'OK') {
    return config;
  } else if (route.queryParamMap.has('terminalInit')) {
    await modal({
      title: 'Bankomat initialisieren',
      dismiss: false,
      component: TerminalModalComponent,
      injector: Injector.create({
        parent: environmentInjector,
        providers: [
          {
            provide: TERMINAL_MODAL_INIT,
            useValue: async (resolveFn) => {
              try {
                await terminalService.init();
                setTimeout(() => {
                  resolveFn(true);
                }, 900);
              } catch (e) {
                handleRequestError(e, injector, { show: true });
                try {
                  await terminalService.close();
                } catch (e) {
                  terminalService.state.set('ERROR');
                  console.log('Terminal initialisieren', terminalService.state());
                  console.error(e);
                } finally {
                  resolveFn(false);
                }
              }
            },
          },
          {
            provide: ActivatedRoute,
            useValue: {
              ...activatedRoute,
              data: activatedRoute.data.pipe(
                map((data) => ({
                  ...data,
                  configuration: config,
                }))
              ),
            },
          },
          {
            provide: TERMINAL_MODAL_SSE_KEY,
            useValue: config?.terminalSseKey,
          },
        ],
      }),
      data: {
        finalizeRequired: false,
      },
    });

    return config;
  }

  return config;
};
